<template>
  <div id="primary-nav">
    <b-container class="primary-nav-container" :class="{ pablo: pablo }">
      <a
        href="https://cubs.fanportal-mlb.com/artists"
        v-ePitchTracking="{
          site: siteId,
          category: 'Project Navigation',
          label: 'Home',
        }"
      >
        <slot></slot>
      </a>
      <b-nav class="p-nav-links" v-b-scrollspy="100">
        <template v-if="!spanish && siteId == 'DeGuzman'">
          <b-nav-item
            class="p-nav-link"
            v-for="(link, index) in deGuzmanLinks"
            :key="'nav' + index"
            :href="link.anchor"
            v-scroll-to="{ el: link.anchor, offset: -90 }"
            v-ePitchTracking="{
              site: currentRouteName,
              category: 'Link - Desktop Nav',
              label: link.anchor,
            }"
          >
            <span> {{ link.title }}</span>
            <div class="underscore" />
          </b-nav-item>
        </template>
        <template v-else-if="!spanish">
          <b-nav-item
            class="p-nav-link"
            v-for="(link, index) in primaryLinks"
            :key="'nav' + index"
            :href="link.anchor"
            v-scroll-to="{ el: link.anchor, offset: -90 }"
            v-ePitchTracking="{
              site: currentRouteName,
              category: 'Link - Desktop Nav',
              label: link.anchor,
            }"
          >
            <span> {{ link.title }}</span>
            <div class="underscore" />
          </b-nav-item>
        </template>
        <template v-else-if="spanish">
          <b-nav-item
            class="p-nav-link"
            v-for="(link, index) in primaryLinksSpanish"
            :key="'nav' + index"
            :href="link.anchor"
            v-scroll-to="{ el: link.anchor, offset: -90 }"
            v-ePitchTracking="{
              site: currentRouteName,
              category: 'Link - Desktop Nav',
              label: link.anchor,
            }"
          >
            <span> {{ link.title }}</span>
            <div class="underscore" />
          </b-nav-item>
        </template>
        <template v-else>
          <b-nav-item
            class="p-nav-link"
            v-for="(link, index) in primaryLinks"
            :key="'nav' + index"
            :href="link.anchor"
            v-scroll-to="{ el: link.anchor, offset: -90 }"
            v-ePitchTracking="{
              site: currentRouteName,
              category: 'Link - Desktop Nav',
              label: link.anchor,
            }"
          >
            <span> {{ link.title }}</span>
            <div class="underscore" />
          </b-nav-item>
        </template>
      </b-nav>

      <svg width="135" height="31" viewBox="0 0 135 31" xmlns="http://www.w3.org/2000/svg" v-bind:class="'respectLogo'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><path d="M101.35 29.522c-7.803 0-14.151-6.349-14.151-14.151 0-7.801 6.348-14.149 14.151-14.149 5.146 0 9.659 2.762 12.135 6.88l-4.095 2.532a9.338 9.338 0 00-8.04-4.596c-5.147 0-9.336 4.187-9.336 9.333 0 5.148 4.189 9.336 9.336 9.336a9.338 9.338 0 008.04-4.598l4.095 2.532c-2.476 4.118-6.989 6.881-12.135 6.881zm7.542-11.158a8.114 8.114 0 01-7.542 5.12 8.112 8.112 0 110-16.225 8.113 8.113 0 017.542 5.12l6.225-3.849C112.6 3.474 107.382 0 101.35 0c-8.49 0-15.372 6.882-15.372 15.371 0 8.49 6.881 15.372 15.372 15.372 6.032 0 11.25-3.474 13.767-8.529l-6.225-3.85z" fill="#FFF"/><path fill="#00306B" d="M114.641 25.062h.358v.975h.242v-.975h.358v-.212h-.958zM116.806 24.85l-.288.776h-.006l-.275-.776h-.421v1.187h.242v-.944h.005l.333.944h.236l.343-.944h.005v.944h.242V24.85z"/><path d="M109.39 20.109a9.338 9.338 0 01-8.04 4.597c-5.147 0-9.335-4.188-9.335-9.335 0-5.146 4.188-9.334 9.335-9.334a9.338 9.338 0 018.04 4.598l4.095-2.532c-2.476-4.12-6.989-6.881-12.135-6.881-7.803 0-14.151 6.347-14.151 14.15 0 7.801 6.348 14.15 14.151 14.15 5.146 0 9.659-2.762 12.135-6.88l-4.095-2.533z" fill="#CE0E2D"/><path d="M6.387 10.08h-3.1v4.446h3.1c1.443 0 2.389-.922 2.389-2.223 0-1.301-.946-2.224-2.39-2.224zM8.94 23.987L5.653 17.27H3.288v6.718H0V7.146h6.6c3.43 0 5.464 2.342 5.464 5.157 0 2.366-1.443 3.832-3.075 4.423l3.76 7.262H8.942zM17.833 23.988V7.146h11.093v2.933h-7.805v3.95h6.646v2.934h-6.646v4.092h7.805v2.933zM39.142 24.13c-2.554 0-4.494-.544-6.15-2.224l2.13-2.129c1.063 1.065 2.507 1.42 4.068 1.42 1.939 0 2.98-.734 2.98-2.082 0-.592-.165-1.088-.52-1.42-.332-.307-.71-.472-1.49-.59l-2.035-.284c-1.443-.213-2.507-.663-3.264-1.396-.804-.804-1.206-1.892-1.206-3.311 0-3.005 2.223-5.11 5.866-5.11 2.318 0 3.997.568 5.44 1.963l-2.081 2.059c-1.065-1.017-2.342-1.16-3.454-1.16-1.75 0-2.601.97-2.601 2.13 0 .425.14.874.496 1.205.331.308.875.569 1.561.663l1.987.284c1.538.213 2.507.639 3.217 1.3.9.852 1.301 2.083 1.301 3.573 0 3.263-2.72 5.109-6.245 5.109M57.212 10.08h-3.076v4.612h3.076c1.49 0 2.436-.923 2.436-2.294 0-1.372-.946-2.319-2.436-2.319m.165 7.57h-3.24v6.339h-3.289V7.146h6.53c3.476 0 5.558 2.39 5.558 5.252 0 2.862-2.082 5.25-5.559 5.25M68.066 23.988V7.146H79.16v2.933h-7.806v3.95H78v2.934h-6.647v4.092h7.806v2.933zM130.433 10.08v13.908h-3.288V10.079h-4.4V7.146h12.088v2.933z" fill="#00306B"/></g></svg>

      <svg width="20" height="10" viewBox="0 0 20 10" xmlns="http://www.w3.org/2000/svg" v-if="!openMenu" v-bind:class="'hamburger-desktop'" v-bind:svg-inline="''" @click="toggleNav()" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#BCBCBC" fill-rule="evenodd"><path d="M0 0h20v2H0zM0 4h20v2H0zM0 8h20v2H0z"/></g></svg>
      <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:class="'close-desktop'" v-bind:svg-inline="''" @click="toggleNav()" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#BCBCBC" fill-rule="evenodd"><path d="M.121 10.243l9.9-9.9 1.414 1.414-9.9 9.9z"/><path d="M1.535.343l9.9 9.9-1.414 1.414-9.9-9.9z"/></g></svg>
    </b-container>
    <div class="desktopMenu" :class="{ active: openMenu }">
      <b-container class="desktopMenuContainer">
        <a
          href="https://cubs.fanportal-mlb.com/artists"
          v-ePitchTracking="{
            site: 'common',
            category: 'Project Navigation',
            label: 'Home',
          }"
          ><h4>HOME</h4></a
        >
        <a
          href="https://cubs.fanportal-mlb.com/artists/louisdeguzman"
          v-ePitchTracking="{
            site: 'common',
            category: 'Project Navigation',
            label: 'Louis De Guzman',
          }"
          ><h4>Louis De Guzman</h4></a
        >
        <div class="previousCollection">
          <h4
            :class="{ active: secondaryLevelOpen }"
            @click="secondaryLevelOpen = !secondaryLevelOpen"
          >
            2021 Collection
            <div class="underscore" />
          </h4>
          <div
            class="previousCollection__links"
            :class="{ active: secondaryLevelOpen }"
          >
            <a
              href="https://cubs.fanportal-mlb.com/artists/bhm"
              v-ePitchTracking="{
                site: 'common',
                category: 'Project Navigation',
                label: 'Nikko Washington',
              }"
              ><h5>Nikko Washington</h5></a
            >
            <a
              href="https://cubs.fanportal-mlb.com/artists/whm"
              v-ePitchTracking="{
                site: 'common',
                category: 'Project Navigation',
                label: 'Kate Lynn Lewis',
              }"
              ><h5>Kate Lynn Lewis</h5></a
            >
            <a
              href="https://cubs.fanportal-mlb.com/artists/pennypinch"
              v-ePitchTracking="{
                site: 'common',
                category: 'Project Navigation',
                label: 'Penny Pinch',
              }"
              ><h5>Penny Pinch</h5></a
            >
            <a
              href="https://cubs.fanportal-mlb.com/artists/efdot"
              v-ePitchTracking="{
                site: 'common',
                category: 'Project Navigation',
                label: 'Efdot',
              }"
              ><h5>Efdot</h5></a
            >
            <a
              href="https://cubs.fanportal-mlb.com/artists/samkirk"
              v-ePitchTracking="{
                site: 'common',
                category: 'Project Navigation',
                label: 'Sam Kirk',
              }"
              ><h5>Sam Kirk</h5></a
            >
            <a
              href="https://cubs.fanportal-mlb.com/artists/pabloserrano"
              v-ePitchTracking="{
                site: 'common',
                category: 'Project Navigation',
                label: 'Pablo Serrano',
              }"
              ><h5>Pablo Serrano</h5></a
            >
          </div>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import { navData, deGuzmanNavData } from "@/data/navData";
import axios from "axios";
export default {
  name: "PrimaryNav",
  data() {
    return {
      primaryLinks: navData(),
      deGuzmanLinks: deGuzmanNavData(),
      openMenu: false,
      secondaryLevelOpen: false,
      primaryLinksSpanish: [
        {
          anchor: "#video",
          title: "Video",
        },
        {
          anchor: "#the-collection",
          title: "LA COLECCIÓN",
        },
        {
          anchor: "#the-story",
          title: "LA HISTORIA",
        },
        {
          anchor: "#the-artist",
          title: "EL ARTISTA",
        },
        {
          anchor: "#the-good",
          title: "EL BIEN",
        },
      ],
    };
  },
  props: {
    siteId: {
      type: String,
      required: true,
    },
    spanish: {
      type: Boolean,
      required: false,
    },
    pablo: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    scrollListener() {
      const scrollY = window.scrollY;
      const gHeight = 46;
      const gMargin = 47;
      const imgHeight = Math.min(611, window.innerWidth) * 0.1892;
      const bp = imgHeight * 0.5;
      const ep = bp + imgHeight;
      const diff = ep - bp;
      const prog = Math.min(Math.max(scrollY - bp, 0), ep);
      const multiplier = Math.min(Math.max(prog / diff, 0), 1);

      const ele = document.getElementById("logoHeader");
      if (!ele) return;
      ele.style.height = multiplier * gHeight;
      ele.style.opacity = multiplier;
      ele.style.marginRight = multiplier * gMargin;
    },
    onActivate(target) {
      axios
        .post(process.env.VUE_APP_API_URL + "/api/router/Tracking.php", {
          site: this.currentRouteName,
          action: "tracking",
          label: target,
          category: "Scrolled To",
        })
        .catch(() => {
          window.console.log("failed tracking");
        });
    },
    toggleNav() {
      const newVal = !this.openMenu;
      this.openMenu = newVal;
      document.documentElement.style.overflow = !newVal ? "auto" : "hidden";
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollListener);
    this.$root.$on("bv::scrollspy::activate", this.onActivate);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollListener);
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
};
</script>

<style lang="scss" scoped>
#primary-nav {
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: #fff;
  .primary-nav-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    &.pablo {
      @media (max-width: 1350px) {
        padding-right: 120px;
      }
    }
  }
  @media (max-width: $xl) {
    .container {
      margin: 0;
      width: 100vw;
      max-width: 100vw;
    }
  }

  svg,
  img {
    height: 100%;
    width: auto;
  }
  .hamburger-desktop {
    width: 20px;
    height: 10px;
    margin-left: 19px;
    cursor: pointer;
    outline: none;
  }
  .close-desktop {
    width: 12px;
    height: 12px;
    margin-left: 19px;
    cursor: pointer;
    outline: none;
  }
  #logoHeader {
    margin-right: 0;
    height: 0;
    width: auto;
    opacity: 0;
    transition: all 75ms linear;
  }
  .respectLogo {
    margin-left: 57px;
    height: 31px;
  }

  /**Adjust this padding for mobile, remove and justify center */
  .p-nav-links {
    display: flex;
    height: 100%;
    flex-direction: row;
    background: transparent;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
    .underscore {
      height: 4px;
      width: 100%;
      opacity: 0;
      background: #eaeaea;
      transition: all 250ms ease-in;
    }
    .active {
      .underscore {
        opacity: 1;
      }
    }
    .nav-link {
      display: flex;
      padding-left: 20px;
      padding-right: 20px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &:first-child {
        padding-left: 0;
      }
      span {
        font-family: "Poppins-SemiBold";
        font-size: 14px;
        color: #7f7f7f !important;
        letter-spacing: 0;
        text-align: left;
        line-height: 20px;
        text-transform: uppercase;
      }
      &:hover {
        cursor: pointer;
        .underscore {
          opacity: 1;
        }
      }
    }
    .p-nav-link,
    .p-nav-link:hover {
      text-decoration: none !important;
    }
  }

  .desktopMenu {
    height: calc(100vh - 80px);
    background-image: url("~@/assets/images/bg/menu-bg.jpg");
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-position: center;
    position: fixed;
    top: 80px;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    transition: all 0.25s ease-in-out;
    visibility: hidden;
    opacity: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 100;
    padding-bottom: 35px;
    transition: all 0.2s ease-in-out;

    &.active {
      visibility: visible;
      opacity: 1;
    }

    h4,
    a {
      font-family: Poppins-Bold;
      font-size: 44.8px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 48px;
      text-transform: uppercase;
    }
    a {
      margin-bottom: 40px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .desktopMenuContainer {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding-bottom: 6%;
    }
    .previousCollection {
      display: flex;
      flex-direction: column;
      h4 {
        font-family: Poppins-Bold;
        font-size: 44.8px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 48px;
        text-transform: uppercase;
        cursor: pointer;
        margin-bottom: 25px;
        border-bottom: none;
        .underscore {
          height: 4px;
          width: 100%;
          opacity: 0;
          background: #eaeaea;
          transition: all 250ms ease-in;
        }
        &:hover,
        &.active {
          .underscore {
            opacity: 1;
          }
        }
      }
      a {
        margin-bottom: 15px;
      }
      h5 {
        color: #ffffff;
        font-family: Poppins-Bold;
        font-size: 24px;
        letter-spacing: 0;
        line-height: 48px;
        margin-bottom: 0;
      }
      &__links {
        display: flex;
        flex-direction: column;
        padding-left: 40px;
        height: fit-content;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease-in-out;
        &.active {
          max-height: 500px;
        }
      }
    }
  }
}
</style>

